export default new class {

  init () {
    this.$toggle = $('[data-gallery-toggler]')
    if (!this.$toggle.length) {
      return
    }
    this.mode = 'photos' // 'photos' or '3d'
    this.$embed = $('.js-3d-model')
    this.$gallery = $('.woo-variation-product-gallery')
    this.$toggle.on('click', () => {
      this.toggle()
    })
  }

  toggle () {
    this.$toggle.find(`[data-when="${this.mode}"]`)
      .hide()
    const newMode = (this.mode === 'photos') ? '3d' : 'photos'
    this.$toggle.find(`[data-when="${newMode}"]`).show()
    if (newMode === '3d') {
      this.$embed.show()
      this.$gallery.addClass('invisible')
    } else {
      this.$embed.hide()
      this.$gallery.removeClass('invisible')
    }
    this.mode = newMode
  }

}



// WEBPACK FOOTER //
// ./scripts/components/toggle-3d.js